import { useAppSelector } from '@/store/hooks';
import { useGetTransmissionReportDetailsQuery } from '@/store/slices/api/reportsApiSlice';

export const useGetTransmissionReportDetails = () => {
  const { activeReportId } = useAppSelector((state) => state.transmissionReports);
  const res = useGetTransmissionReportDetailsQuery(activeReportId ?? 0, {
    skip: !activeReportId
  });
  return res;
};
